/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-no-comment-textnodes */
import React from 'react';
import Image from 'src/shared/components/Image';
import styles from './styles.module.scss';
import classnames from 'classnames';
import { fireGA } from 'src/utils/gaUtils';
import Link from 'src/shared/components/Link';

interface Props {
    isMobile?: boolean;
    title: string;
    description: string;
    imgSrc: string;
    href: string;
    gaLabel: string;
}

const CommonTypeCard = (props: Props) => {
    const onClick = () => {
        fireGA('marketingQ421', 'clickPrivateMarketProducts', props.gaLabel);
    };

    return (
        <Link href={props.href}>
            <a className={classnames(styles.container, { [styles.mobile]: props.isMobile })} onClick={onClick}>
                <Image className={styles.img} src={props.imgSrc} />
                <div className={styles.content}>
                    <p className={styles.title}>{props.title}</p>
                    <p className={styles.description}>{props.description}</p>
                </div>
            </a>
        </Link>
    );
};

CommonTypeCard.defaultProps = {
    isMobile: false,
};

export default CommonTypeCard;
